import { render, staticRenderFns } from "./vendor_sites_name.vue?vue&type=template&id=51c1981e&scoped=true&"
import script from "./vendor_sites_name.vue?vue&type=script&lang=js&"
export * from "./vendor_sites_name.vue?vue&type=script&lang=js&"
import style0 from "./vendor_sites_name.vue?vue&type=style&index=0&id=51c1981e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c1981e",
  null
  
)

export default component.exports